import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';

// Custom TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const Social = ({ className = "", iconSize = "w-6 h-6" }) => {
  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://instagram.com/tarotdearlene',
      icon: Instagram,
      label: '@tarotdearlene'
    },
    {
      name: 'Facebook',
      url: 'https://facebook.com/tarotdearlene',
      icon: Facebook,
      label: 'Facebook'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@arlenetarot',
      icon: Youtube,
      label: 'YouTube'
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@tarotdearlene',
      icon: TikTokIcon,
      label: 'TikTok'
    }
  ];

  return (
    <div className={`flex space-x-4 ${className}`}>
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-pink-400 transition-colors duration-200"
          aria-label={social.label}
        >
          <social.icon className={`${iconSize} text-gray-600 hover:text-pink-400`} />
        </a>
      ))}
    </div>
  );
};

export default Social;
